export default __webpack_public_path__ + "static/media/ikhc.3556e16b.jpg";